import React from 'react';
import FormikDescription from 'gui/components/formikDescription';

export interface ITicketDescriptionProps {
  name?: string;
  values?: any;
  loading?: boolean;
}

const TicketDescription = (props: ITicketDescriptionProps) => {
  return (
    <FormikDescription
      name={props.name}
      values={props.values}
      label={`שירותים כלולים (מזוודות, ארוחות, מושבים, מידע על עצירות וכו)`}
      loading={props.loading}
    />
  );
};

TicketDescription.defaultProps = {
  name: "additionalServices",
  values: {},
};

export default React.memo(TicketDescription);
